import type { IntakeTemplate } from '../templateTypes';
import { templatePrismeKmiV1 } from './prisme-kmi-v1';

export const templatePrismeKmiCibleV1: IntakeTemplate = {
  ...templatePrismeKmiV1,
  id: 'prisme-kmi-cible-v1',
  name: 'Prisme - KMI (maturité cible Futur)',
  description:
    'Questionnaire KMI structuré en 6 piliers pour définir la maturité cible Futur. Chaque question utilise une échelle de 0 à 5 selon l’état visé.',
  documentTypeCode: 'PRISME_KMI_CIBLE',
};
